export type Language = 'en' | 'vi';

export const translations = {
  en: {
    // Navigation
    dashboard: 'Dashboard',
    todaysRevenue: "Today's Revenue",
    topSellingItemsToday: 'Top Selling Items Today',
    categories: 'Categories',
    menu: 'Menu',
    materials: 'Materials',
    warehouses: 'Warehouses',
    assets: 'Assets',
    manufacturing: 'Manufacturing',
    manufactured: 'Manufactured',
    manufacture: 'Manufacture',
    quantityProduced: 'Quantity Produced',
    recipeYieldLabel: 'Recipe Yield',
    manufacturingRecipe: 'Manufacturing Recipe',
    direct: 'Direct',
    recipes: 'Recipes',
    orders: 'Orders',
    analytics: 'Analytics',
    users: 'Users',
    customers: 'Customers',
    logout: 'Logout',
    account: 'Account',
    language: 'Language',

    // Common
    all: 'All',
    add: 'Add',
    edit: 'Edit',
    revenue: 'Revenue',
    profit: 'Profit',
    delete: 'Delete',
    cancel: 'Cancel',
    save: 'Save',
    update: 'Update',
    clear: 'Clear',
    submit: 'Submit',
    active: 'Active',
    inactive: 'Inactive',
    addOrder: 'Add order',
    addItem: 'Add item',
    more: 'More',
    quickLinks: 'Quick links',
    manageMaterials: 'Manage materials and stock levels',
    manageManufacturing: 'Run production and track history',
    viewRecipes: 'View and edit recipes',
    manageUsers: 'Manage staff accounts',
    manageCustomers: 'Manage customer profiles',
    viewCustomers: 'View customers',
    manageWarehouses: 'Manage warehouse locations and stock',
    manageAssets: 'Track equipment and assets',
    manageCategories: 'Manage menu categories',
    manageMenu: 'Manage menu items',
    loading: 'Loading...',
    search: 'Search',
    filters: 'Filters',
    actions: 'Actions',
    view: 'View',
    recipe: 'Recipe',
    product: 'Product',
    products: 'Products',
    productsManagement: 'Products Management',
    productName: 'Product Name',
    productType: 'Product Type',
    directProduct: 'Direct Product',
    category: 'Category',
    selectCategory: 'Select Category',
    allCategories: 'All Categories',
    type: 'Type',
    allTypes: 'All Types',
    allStatuses: 'All Statuses',
    activate: 'Activate',
    deactivate: 'Deactivate',
    addProduct: 'Add Product',
    productCreatedSuccessfully: 'Product created successfully',
    productUpdatedSuccessfully: 'Product updated successfully',
    productDeletedSuccessfully: 'Product deleted successfully',
    failedToCreateProduct: 'Failed to create product',
    failedToUpdateProduct: 'Failed to update product',
    failedToDeleteProduct: 'Failed to delete product',
    pleaseEnterProductName: 'Please enter product name',
    materialConfiguration: 'Material Configuration',
    materialConfigurationDescription: 'Configure the raw material for this direct product',
    materialName: 'Material Name',
    unit: 'Unit',
    selectUnit: 'Select Unit',
    'unit.g': 'g',
    'unit.kg': 'kg',
    grams: 'grams',
    kilograms: 'kilograms',
    'unit.ml': 'ml',
    'unit.l': 'l',
    milliliters: 'milliliters',
    liters: 'liters',
    'unit.bottle': 'Bottle',
    'unit.can': 'Can',
    pieces: 'Pieces',
    costPerUnit: 'Cost Per Unit',
    currentStock: 'Current Stock',
    minStockLevel: 'Min Stock Level',
    productDetails: 'Product Details',
    pleaseEnterMaterialName: 'Please enter material name',
    pleaseSelectUnit: 'Please select unit',
    pleaseEnterMinStockLevel: 'Please enter minimum stock level',
    pleaseSelectCategory: 'Please select category',
    productsList: 'Products List',
    viewAndManageProducts: 'View and manage all your products',
    searchProducts: 'Search products...',
    totalProducts: 'Total Products',
    activeProducts: 'Active Products',
    inactiveProducts: 'Inactive Products',
    productCategories: 'Product categories',
    noProductsFound: 'No products found',
    tryAdjustingFilters: 'Try adjusting your filters',
    uploadingImage: 'Uploading image...',
    imageUpdatedSuccessfully: 'Image updated successfully',
    failedToUploadImage: 'Failed to upload image',
    reset: 'Reset',
    confirm: 'Confirm',
    description: 'Description',
    categoryTagsManagement: 'Category Tags',
    totalTags: 'Total Tags',
    usedTags: 'Used Tags',
    noCategoryTagsFound: 'No Category Tags Found',
    createFirstTagToStart: 'Create your first category tag to start organizing your categories.',
    errorLoadingTags: 'Error loading category tags',
    retry: 'Retry',
    createTag: 'Create Tag',
    editTag: 'Edit Tag',
    tagName: 'Tag Name',
    enterTagName: 'Enter tag name',
    slug: 'Slug',
    urlFriendlySlug: 'URL-friendly slug',
    color: 'Color',
    selectColor: 'Select color',
    tagDescription: 'Tag description (optional)',
    confirmDelete: 'Confirm Delete',
    deleteTagWarning: 'Are you sure you want to delete this tag? This action cannot be undone.',
    tagCannotBeDeleted: 'This tag cannot be deleted because it is being used by categories.',
    categoryTags: 'Category Tags',
    manageCategoryTags: 'Manage category tags and colors',
    theme: 'Theme',
    lightTheme: 'Light',
    darkTheme: 'Dark',
    systemTheme: 'System',
    darkMode: 'Dark Mode',
    themeOptions: 'Theme Options',
    themeOptionsDescription: 'Choose your preferred theme appearance:\n\n• Light: Bright theme for daytime use\n• Dark: Dark theme for nighttime use\n• System: Automatically switch based on device settings',
    selectTheme: 'Select theme',
    gotIt: 'Got It',
    settings: 'Settings',
    actionLogs: 'Action Logs',
    viewActionLogs: 'View system activity and audit trail',
    overview: 'Overview',
    totalLogs: 'Total Logs',
    authEvents: 'Auth Events',
    criticalEvents: 'Critical Events',
    recentActivity: 'Recent Activity',
    activeFilters: 'Active Filters',
    clearFilters: 'Clear Filters',
    searchLogs: 'Search logs...',
    applyFilters: 'Apply Filters',
    pullToRefresh: 'Pull to refresh',
    loadingMore: 'Loading more...',
    noLogsMatchFilters: 'No logs match your filters',
    noActionLogs: 'No action logs found',
    actionLogsWillAppear: 'Action logs will appear here as users interact with the system',
    exportLogs: 'Export Logs',
    exportLogsMessage: 'Export current filtered logs to CSV file. This will download all logs matching your current filters.',
    image: 'Image',
    upload: 'Upload',
    change: 'Change',
    noImageSelected: 'No image selected',
    seeDetails: 'See details',
    seeAll: 'See all',
    viewMaterials: 'View materials',
    noData: 'No data available',
    unknown: 'Unknown',
    importHistory: 'Import History',
    noHistory: 'No history yet',
    totalPrice: 'Total Price',
    totalValue: 'Total value',
    warehouse: 'Warehouse',
    location: 'Location',
    yearsOfUse: 'Years of use',
    consumptionCost: 'Consumption cost',
    notes: 'Notes',
    recipeDetails: 'Recipe Details',
    totalRecipeCost: 'Total Recipe Cost',
    sellingPrice: 'Selling Price',
    profitMargin: 'Profit Margin',
    ingredients: 'Ingredients',
    material: 'Material',
    rawMaterial: 'Raw material',
    noIngredientsYet: 'No ingredients yet.',
    selectMaterial: 'Select material',
    addIngredients: 'Add ingredients',
    value: 'Value',
    purchaseDate: 'Purchase date',
    ingredientsAddedSuccessfully: 'Ingredients added successfully!',
    ingredientsUpdated: 'Ingredients updated successfully!',
    failedToAddIngredients: 'Failed to add ingredients',
    failedToUpdateIngredients: 'Failed to update ingredients',
    pleaseSelectMenuItem: 'Please select a menu item first',
    pleaseAddIngredient: 'Please add at least one ingredient with quantity',
    ingredientAdded: 'Ingredient added',
    ingredientUpdated: 'Ingredient updated',
    ingredientDeleted: 'Ingredient deleted',
    failedToSaveIngredient: 'Failed to save ingredient',
    failedToDeleteIngredient: 'Failed to delete ingredient',
    editIngredient: 'Edit ingredient',
    deleteIngredient: 'Delete ingredient',
    enterQuantity: 'Enter quantity',
    selected: 'Selected',
    customerName: 'Customer name',
    orderCreatedSuccessfully: 'Order created successfully!',
    orderCreateFailed: 'Failed to create order',
    orderRequiresItems: 'Please add at least one item to the order',
    walkInCustomer: 'Walk-in customer',
    newCustomer: 'New customer',
    paymentMethod: 'Payment method',
    cash: 'Cash',
    card: 'Card',
    transfer: 'Transfer',
    selectMenuItem: 'Select menu item',
    addUser: 'Add user',
    userCreatedSuccessfully: 'User created successfully!',
    userCreateFailed: 'Failed to create user',
    userDeleted: 'User deleted',
    userDeleteFailed: 'Failed to delete user',
    addCustomer: 'Add customer',
    editCustomer: 'Edit customer',
    deleteCustomer: 'Delete customer',
    customerCreatedSuccessfully: 'Customer created successfully!',
    customerCreateFailed: 'Failed to create customer',
    customerUpdatedSuccessfully: 'Customer updated successfully!',
    customerUpdateFailed: 'Failed to update customer',
    customerDeletedSuccessfully: 'Customer deleted successfully!',
    customerDeleteFailed: 'Failed to delete customer',
    enterCustomerName: 'Enter customer name',
    noCustomersYet: 'No customers yet.',
    customersWillAppear: 'New customers will appear here after their first order.',
    firstOrder: 'First order',
    lastOrder: 'Last order',
    markAsPaid: 'Mark as paid',
    markAsUnpaid: 'Mark as unpaid',
    selectOrders: 'Select orders',
    cancelSelection: 'Cancel selection',
    print: 'Print',
    export: 'Export',
    exportCsv: 'Export CSV',
    orderMarkedAsPaid: 'Order marked as paid',
    orderMarkedAsUnpaid: 'Order marked as unpaid',
    ordersMarkedAsPaidBulk: 'Orders marked as paid',
    ordersMarkedAsUnpaidBulk: 'Orders marked as unpaid',
    failedToUpdate: 'Failed to update',
    orderDeleted: 'Order deleted',
    orderDeleteFailed: 'Failed to delete order',
    orderUpdateFailed: 'Failed to update orders',
    ordersDeleted: 'Orders deleted',
    ordersDeleteFailed: 'Failed to delete orders',
    ordersExported: 'Orders exported',
    printOrders: 'Print orders',
    printDate: 'Print date',
    printUnavailable: 'Unable to open print view',
    noOrderData: 'No order data available',
    price: 'Price',
    recipesWithCost: 'Tracked recipes',
    profitabilitySummary: 'Aggregated profit across products',
    bestPerformingRecipes: 'Top profit recipes',
    leastPerformingRecipes: 'Lowest profit recipes',
    noProfitabilityData: 'No profitability data yet.',
    deleteOrder: 'Delete order',
    confirmDeleteOrder: 'Are you sure you want to delete this order?',
    manufacturingHistory: 'Manufacturing History',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    confirmDeleteHistory: 'Delete entry?',
    totalCost: 'Total Cost',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    editProcessedMaterial: 'Edit processed material',
    confirmDeleteProcessedMaterial: 'Delete processed material?',
    deleteProcessedMaterialMessage: 'This will remove the processed material and its manufacturing history.',
    failedToDeleteProcessedMaterial: 'Failed to delete processed material.',
    deleting: 'Deleting…',

    // Login
    adminPanel: 'Admin Panel',
    username: 'Username',
    password: 'Password',
    login: 'Login',
    enterUsername: 'Please enter your username',
    enterPassword: 'Please enter your password',
    invalidCredentials: 'Invalid credentials',
    loggingIn: 'Logging in...',

    // Dashboard
    ordersProcessed: 'Orders Processed',
    netProfit: 'Net Profit',
    performanceOverview: 'Performance Overview',
    orderVolume: 'Order Volume',
    revenueTrend: 'Revenue Trend',
    topSellingItems: 'Top Selling Items',
    noSalesToday: 'No sales recorded for today yet.',
    recentOrders: 'Recent Orders',
    noOrdersFound: 'No orders found for this filter.',

    // Orders
    totalRevenue: 'Total Revenue',
    totalOrders: 'Total Orders',
    todayOrders: "Today's Orders",
    unpaidOrders: 'Unpaid Orders',
    paid: 'Paid',
    unpaid: 'Unpaid',
    today: 'Today',
    orderSummary: 'Order Summary',
    customer: 'Customer',
    totalAmount: 'Total Amount',
    status: 'Status',
    orderDate: 'Order Date',
    totalProfit: 'Total profit',
    productProfitability: 'Product Profitability',
    avgCostLabel: 'Average cost',
    avgProfit: 'Average profit',
    avgMargin: 'Average margin',
    timesSold: 'Times sold',
    totalQuantity: 'Total quantity',
    slowMovers: 'Slow Movers',
    lastSold: 'Last sold',
    neverSold: 'Never sold',
    inventoryOverview: 'Inventory Overview',
    averageStockValue: 'Average stock value',
    lowStockCount: 'Low stock items',
    totalItems: 'Total items',
    productionLast30Days: 'Batches (30d)',
    totalRecipes: 'Total recipes',
    batchesRecorded: 'Batches recorded',
    totalWarehouses: 'Total warehouses',
    inactiveWarehouses: 'Inactive warehouses',
    warehouseStatusSummary: 'Warehouse status summary',
    addWarehouse: 'Add warehouse',
    editWarehouse: 'Edit warehouse',
    enterWarehouseName: 'Please enter warehouse name',
    warehouseCreated: 'Warehouse created',
    warehouseCreateFailed: 'Failed to create warehouse',
    warehouseUpdated: 'Warehouse updated',
    warehouseUpdateFailed: 'Failed to update warehouse',
    warehouseDeleted: 'Warehouse deleted',
    warehouseDeleteFailed: 'Failed to delete warehouse',
    locationUnknown: 'Location unavailable',
    confirmDeleteWarehouse: 'Delete this warehouse?',
    deleteWarehouseMessage: 'This action cannot be undone.',
    totalCategories: 'Total categories',
    inactiveCategories: 'Inactive categories',
    categoryStatusSummary: 'Category status summary',
    addCategory: 'Add category',
    editCategory: 'Edit category',
    enterCategoryName: 'Please enter category name',
    categoryCreated: 'Category created',
    categoryCreateFailed: 'Failed to create category',
    categoryUpdated: 'Category updated',
    categoryUpdateFailed: 'Failed to update category',
    categoryDeleted: 'Category deleted',
    categoryDeleteFailed: 'Failed to delete category',
    categoryTag: 'Tag',
    categoryName: 'Category name',
    confirmDeleteCategory: 'Delete this category?',
    deleteCategoryMessage: 'This action cannot be undone.',
    none: 'None',
    addAsset: 'Add asset',
    editAsset: 'Edit asset',
    assetCreatedSuccessfully: 'Asset created successfully',
    failedToCreateAsset: 'Failed to create asset',
    assetUpdatedSuccessfully: 'Asset updated successfully',
    failedToUpdateAsset: 'Failed to update asset',
    assetDeletedSuccessfully: 'Asset deleted successfully',
    failedToDeleteAsset: 'Failed to delete asset',
    enterAssetName: 'Please enter asset name',
    enterValidValue: 'Enter a valid value',
    enterValidYears: 'Enter years of use',
    totalAssets: 'Total assets',
    totalConsumption: 'Consumption cost',
    averageDepreciation: 'Average depreciation',
    confirmDeleteAsset: 'Delete this asset?',
    deleteAssetMessage: 'This action cannot be undone.',
    menuManagement: 'Menu management',
    addMenuItem: 'Add menu item',
    editMenuItem: 'Edit menu item',
    menuItemCreated: 'Menu item created',
    menuItemCreateFailed: 'Failed to create menu item',
    menuItemUpdated: 'Menu item updated',
    menuItemUpdateFailed: 'Failed to update menu item',
    menuItemDeleted: 'Menu item deleted',
    menuItemDeleteFailed: 'Failed to delete menu item',
    selectProduct: 'Select product',
    enterValidPrice: 'Enter a valid price',
    menuExported: 'Menu exported',
    menuImported: 'Menu imported',
    menuImportFailed: 'Failed to import menu',
    importCsv: 'Import CSV',

    // Inventory
    inventory: 'Inventory',
    stockValue: 'Stock Value',
    lowStockAlerts: 'Low Stock Alerts',
    lowStock: 'Low Stock',
    inStock: 'In Stock',
    empty: 'Empty',
    topValuedMaterials: 'Top Valued Materials',
    stock: 'Stock',
    warehouseDistribution: 'Warehouse Distribution',
    quantity: 'Quantity',
    date: 'Date',
    selectWarehouse: 'Select Warehouse',
    addImport: 'Add Import',
    addWarehouseRow: 'Add Warehouse',
    removeRow: 'Remove',
    enterCostPerUnit: 'Enter cost per unit',
    saving: 'Saving…',
    addProcessedMaterial: 'Add processed material',
    addMaterial: 'Add material',
    materialCreatedSuccessfully: 'Material created successfully!',
    materialCreateFailed: 'Failed to create material',
    useAsIngredient: 'Use as ingredient',
    bottle: 'Bottle',
    can: 'Can',
    packed: 'Packed',
    name: 'Name',
    enterName: 'Enter name',

    // Analytics
    dateRange: 'Date Range',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    thisYear: 'This Year',
    customRange: 'Custom Range',
    trends: 'Trends',
    performanceSummary: 'Performance Summary',
    averageOrderValue: 'Average Order Value',
    itemsSold: 'Items Sold',
    bestSellers: 'Best Sellers',
    noAnalyticsData: 'No analytics data for this range.',
    cost: 'Cost',
    margin: 'Margin',
    inventorySummary: 'Inventory Summary',
    lowStockItems: 'Low Stock Items',
    slowMovingProducts: 'Slow Moving Products',
    daysInStock: 'Days in Stock',
    inventoryValue: 'Inventory Value',
    noSlowMovers: 'No slow moving products found.',
    salesTrend: 'Sales Trend',
    dailySales: 'Daily Sales',
    profitAnalysis: 'Profit Analysis',
    exportData: 'Export Data',
    selectDateRange: 'Select Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    apply: 'Apply',
    revenueTrendTitle: 'Revenue Trend',
    avgOrderValue: 'Avg Order Value',
    perOrder: 'per order',
    profitable: 'Profitable',
    sold: 'sold',
    growing: 'Growing',
    avg: 'avg',
    allStockLevelsGood: 'All Stock Levels Good',
    categoryBreakdown: 'Category Breakdown',
    items: 'items',
    never: 'Never',
    customDateRange: 'Custom Date Range',
    exportAnalytics: 'Export Analytics',
    exportAnalyticsMessage: 'Export current analytics data to CSV file for detailed analysis.',

    // Session
    sessionRequiredTitle: 'Session Required',
    sessionRequiredMessage: 'You are not signed in. Redirecting to login…',

    // Notifications
    notifications: 'Notifications',
    markAllAsRead: 'Mark all as read',
    noNotifications: 'No notifications',
    noUnreadNotifications: 'No unread notifications',
    unread: 'Unread',
    info: 'Info',
    success: 'Success',
    warning: 'Warning',
    error: 'Error',
    manufacturedDate: 'Manufactured Date',
    manufacturedDateRequired: 'Manufactured date is required',

    // Language names
    english: 'English',
    vietnamese: 'Vietnamese',
  },
  vi: {
    dashboard: 'Bảng điều khiển',
    todaysRevenue: 'Doanh thu hôm nay',
    topSellingItemsToday: 'Mặt hàng bán chạy hôm nay',
    categories: 'Danh mục',
    menu: 'Thực đơn',
    materials: 'Nguyên liệu',
    warehouses: 'Kho hàng',
    assets: 'Tài sản',
    manufacturing: 'Sản xuất',
    manufactured: 'Đã sản xuất',
    manufacture: 'Sản xuất',
    quantityProduced: 'Số lượng sản xuất',
    recipeYieldLabel: 'Sản lượng công thức',
    manufacturingRecipe: 'Công thức sản xuất',
    direct: 'Trực tiếp',
    recipes: 'Công thức',
    orders: 'Đơn hàng',
    analytics: 'Phân tích',
    users: 'Người dùng',
    customers: 'Khách hàng',
    logout: 'Đăng xuất',
    account: 'Tài khoản',
    language: 'Ngôn ngữ',

    all: 'Tất cả',
    add: 'Thêm',
    edit: 'Sửa',
    revenue: 'Doanh thu',
    profit: 'Lợi nhuận',
    delete: 'Xóa',
    cancel: 'Hủy',
    save: 'Lưu',
    update: 'Cập nhật',
    clear: 'Xóa',
    submit: 'Gửi',
    active: 'Hoạt động',
    inactive: 'Ngưng hoạt động',
    addOrder: 'Tạo đơn hàng',
    addItem: 'Thêm món',
    more: 'Thêm',
    quickLinks: 'Liên kết nhanh',
    manageMaterials: 'Quản lý nguyên liệu và tồn kho',
    manageManufacturing: 'Quản lý sản xuất và lịch sử',
    viewRecipes: 'Xem và chỉnh sửa công thức',
    manageUsers: 'Quản lý tài khoản nhân viên',
    manageCustomers: 'Quản lý khách hàng',
    viewCustomers: 'Xem khách hàng',
    manageWarehouses: 'Quản lý kho và hàng tồn',
    manageAssets: 'Theo dõi thiết bị, tài sản',
    manageCategories: 'Quản lý danh mục menu',
    manageMenu: 'Quản lý món trong menu',
    loading: 'Đang tải...',
    search: 'Tìm kiếm',
    filters: 'Bộ lọc',
    actions: 'Hành động',
    view: 'Xem',
    recipe: 'Công thức',
    product: 'Sản phẩm',
    products: 'Sản phẩm',
    productsManagement: 'Quản lý sản phẩm',
    productName: 'Tên sản phẩm',
    productType: 'Loại sản phẩm',
    directProduct: 'Sản phẩm trực tiếp',
    category: 'Danh mục',
    selectCategory: 'Chọn danh mục',
    allCategories: 'Tất cả danh mục',
    type: 'Loại',
    allTypes: 'Tất cả loại',
    allStatuses: 'Tất cả trạng thái',
    activate: 'Kích hoạt',
    deactivate: 'Vô hiệu hóa',
    addProduct: 'Thêm sản phẩm',
    productCreatedSuccessfully: 'Tạo sản phẩm thành công',
    productUpdatedSuccessfully: 'Cập nhật sản phẩm thành công',
    productDeletedSuccessfully: 'Xóa sản phẩm thành công',
    failedToCreateProduct: 'Thất bại khi tạo sản phẩm',
    failedToUpdateProduct: 'Thất bại khi cập nhật sản phẩm',
    failedToDeleteProduct: 'Thất bại khi xóa sản phẩm',
    pleaseEnterProductName: 'Vui lòng nhập tên sản phẩm',
    materialConfiguration: 'Cấu hình nguyên liệu',
    materialName: 'Tên nguyên liệu',
    unit: 'Đơn vị',
    selectUnit: 'Chọn đơn vị',
    'unit.g': 'g',
    'unit.kg': 'kg',
    grams: 'gam',
    kilograms: 'kilôgam',
    'unit.ml': 'ml',
    'unit.l': 'l',
    milliliters: 'mililit',
    liters: 'lít',
    'unit.bottle': 'Chai',
    'unit.can': 'Lon',
    pieces: 'Cái',
    costPerUnit: 'Chi phí mỗi đơn vị',
    currentStock: 'Tồn kho hiện tại',
    minStockLevel: 'Mức tồn kho tối thiểu',
    pleaseEnterMaterialName: 'Vui lòng nhập tên nguyên liệu',
    pleaseSelectUnit: 'Vui lòng chọn đơn vị',
    pleaseEnterMinStockLevel: 'Vui lòng nhập mức tồn kho tối thiểu',
    pleaseSelectCategory: 'Vui lòng chọn danh mục',
    productsList: 'Danh sách sản phẩm',
    viewAndManageProducts: 'Xem và quản lý tất cả sản phẩm',
    searchProducts: 'Tìm kiếm sản phẩm...',
    totalProducts: 'Tổng số sản phẩm',
    activeProducts: 'Sản phẩm hoạt động',
    inactiveProducts: 'Sản phẩm không hoạt động',
    productCategories: 'Danh mục sản phẩm',
    noProductsFound: 'Không tìm thấy sản phẩm',
    tryAdjustingFilters: 'Thử điều chỉnh bộ lọc',
    uploadingImage: 'Đang tải hình ảnh...',
    imageUpdatedSuccessfully: 'Cập nhật hình ảnh thành công',
    failedToUploadImage: 'Thất bại khi tải hình ảnh',
            viewMaterials: 'Xem nguyên liệu',
    noData: 'Không có dữ liệu',
    unknown: 'Không xác định',
    importHistory: 'Lịch sử nhập',
    noHistory: 'Chưa có lịch sử',
    totalPrice: 'Tổng giá',
    totalValue: 'Tổng giá trị',
    warehouse: 'Kho',
    location: 'Vị trí',
    yearsOfUse: 'Số năm sử dụng',
    consumptionCost: 'Chi phí khấu hao',
    notes: 'Ghi chú',
    recipeDetails: 'Chi tiết công thức',
    totalRecipeCost: 'Tổng chi phí công thức',
    sellingPrice: 'Giá bán',
    profitMargin: 'Tỷ suất lợi nhuận',
    ingredients: 'Nguyên liệu',
    material: 'Nguyên liệu',
    rawMaterial: 'Nguyên liệu thô',
    noIngredientsYet: 'Chưa có nguyên liệu.',
    selectMaterial: 'Chọn nguyên liệu',
    addIngredients: 'Thêm nguyên liệu',
    value: 'Giá trị',
    purchaseDate: 'Ngày mua',
    ingredientsAddedSuccessfully: 'Thêm nguyên liệu thành công!',
    ingredientsUpdated: 'Cập nhật nguyên liệu thành công!',
    failedToAddIngredients: 'Không thể thêm nguyên liệu',
    failedToUpdateIngredients: 'Không thể cập nhật nguyên liệu',
    pleaseSelectMenuItem: 'Vui lòng chọn món trước',
    pleaseAddIngredient: 'Vui lòng thêm ít nhất một nguyên liệu với số lượng',
    ingredientAdded: 'Đã thêm nguyên liệu',
    ingredientUpdated: 'Đã cập nhật nguyên liệu',
    ingredientDeleted: 'Đã xóa nguyên liệu',
    failedToSaveIngredient: 'Không thể lưu nguyên liệu',
    failedToDeleteIngredient: 'Không thể xóa nguyên liệu',
    editIngredient: 'Chỉnh sửa nguyên liệu',
    deleteIngredient: 'Xóa nguyên liệu',
    enterQuantity: 'Nhập số lượng',
    selected: 'Đã chọn',
    customerName: 'Tên khách hàng',
    orderCreatedSuccessfully: 'Tạo đơn hàng thành công!',
    orderCreateFailed: 'Tạo đơn hàng thất bại',
    orderRequiresItems: 'Vui lòng thêm ít nhất một món vào đơn',
    walkInCustomer: 'Khách vãng lai',
    newCustomer: 'Khách hàng mới',
    paymentMethod: 'Phương thức thanh toán',
    cash: 'Tiền mặt',
    card: 'Thẻ',
    transfer: 'Chuyển khoản',
    selectMenuItem: 'Chọn món',
    addUser: 'Thêm người dùng',
    userCreatedSuccessfully: 'Thêm người dùng thành công!',
    userCreateFailed: 'Không thể thêm người dùng',
    userDeleted: 'Đã xóa người dùng',
    userDeleteFailed: 'Không thể xóa người dùng',
    addCustomer: 'Thêm khách hàng',
    editCustomer: 'Chỉnh sửa khách hàng',
    deleteCustomer: 'Xóa khách hàng',
    customerCreatedSuccessfully: 'Thêm khách hàng thành công!',
    customerCreateFailed: 'Không thể thêm khách hàng',
    customerUpdatedSuccessfully: 'Cập nhật khách hàng thành công!',
    customerUpdateFailed: 'Không thể cập nhật khách hàng',
    customerDeletedSuccessfully: 'Đã xóa khách hàng',
    customerDeleteFailed: 'Không thể xóa khách hàng',
    enterCustomerName: 'Nhập tên khách hàng',
    noCustomersYet: 'Chưa có khách hàng.',
    customersWillAppear: 'Khách hàng mới sẽ xuất hiện khi có đơn hàng đầu tiên.',
    firstOrder: 'Đơn đầu tiên',
    lastOrder: 'Đơn gần nhất',
    markAsPaid: 'Đánh dấu đã thanh toán',
    markAsUnpaid: 'Đánh dấu chưa thanh toán',
    selectOrders: 'Chọn đơn',
    cancelSelection: 'Hủy chọn',
    print: 'In',
    export: 'Xuất',
    exportCsv: 'Xuất CSV',
    orderMarkedAsPaid: 'Đơn hàng đã được đánh dấu đã thanh toán',
    orderMarkedAsUnpaid: 'Đơn hàng đã được đánh dấu chưa thanh toán',
    ordersMarkedAsPaidBulk: 'Các đơn đã được đánh dấu đã thanh toán',
    ordersMarkedAsUnpaidBulk: 'Các đơn đã được đánh dấu chưa thanh toán',
    failedToUpdate: 'Cập nhật thất bại',
    orderDeleted: 'Đã xóa đơn hàng',
    orderDeleteFailed: 'Không thể xóa đơn hàng',
    orderUpdateFailed: 'Không thể cập nhật đơn hàng',
    ordersDeleted: 'Đã xóa đơn hàng',
    ordersDeleteFailed: 'Không thể xóa các đơn hàng',
    ordersExported: 'Đã xuất đơn hàng',
    printOrders: 'In đơn hàng',
    printDate: 'Thời gian in',
    printUnavailable: 'Không thể mở chế độ in',
    noOrderData: 'Không có dữ liệu đơn hàng',
    price: 'Giá',
    recipesWithCost: 'Công thức đã tính giá vốn',
    profitabilitySummary: 'Tổng lợi nhuận theo sản phẩm',
    bestPerformingRecipes: 'Công thức lợi nhuận cao',
    leastPerformingRecipes: 'Công thức lợi nhuận thấp',
    noProfitabilityData: 'Chưa có dữ liệu lợi nhuận.',
    deleteOrder: 'Xóa đơn hàng',
    confirmDeleteOrder: 'Bạn có chắc muốn xóa đơn hàng này?',
    manufacturingHistory: 'Lịch sử sản xuất',
    last7Days: '7 ngày qua',
    last30Days: '30 ngày qua',
    confirmDeleteHistory: 'Xóa ghi nhận này?',
    totalCost: 'Tổng chi phí',
    yes: 'Có',
    no: 'Không',
    close: 'Đóng',
    editProcessedMaterial: 'Chỉnh sửa nguyên liệu chế biến',
    confirmDeleteProcessedMaterial: 'Xóa nguyên liệu chế biến?',
    deleteProcessedMaterialMessage: 'Hành động này sẽ xóa nguyên liệu chế biến và toàn bộ lịch sử sản xuất.',
    failedToDeleteProcessedMaterial: 'Không thể xóa nguyên liệu chế biến.',
    deleting: 'Đang xóa…',

    adminPanel: 'Bảng quản trị',
    username: 'Tên đăng nhập',
    password: 'Mật khẩu',
    login: 'Đăng nhập',
    enterUsername: 'Vui lòng nhập tên đăng nhập',
    enterPassword: 'Vui lòng nhập mật khẩu',
    invalidCredentials: 'Thông tin đăng nhập không hợp lệ',
    loggingIn: 'Đang đăng nhập...',

    ordersProcessed: 'Đơn đã xử lý',
    netProfit: 'Lợi nhuận ròng',
    performanceOverview: 'Hiệu suất tổng quan',
    orderVolume: 'Số lượng đơn',
    revenueTrend: 'Xu hướng doanh thu',
    topSellingItems: 'Mặt hàng bán chạy',
    noSalesToday: 'Chưa có doanh số hôm nay.',
    recentOrders: 'Đơn hàng gần đây',
    noOrdersFound: 'Không tìm thấy đơn hàng.',

    totalRevenue: 'Tổng doanh thu',
    totalOrders: 'Tổng số đơn',
    todayOrders: 'Đơn hôm nay',
    unpaidOrders: 'Đơn chưa thanh toán',
    paid: 'Đã thanh toán',
    unpaid: 'Chưa thanh toán',
    today: 'Hôm nay',
    orderSummary: 'Tổng quan đơn hàng',
    customer: 'Khách hàng',
    totalAmount: 'Tổng tiền',
    status: 'Trạng thái',
    orderDate: 'Ngày đặt',
    totalProfit: 'Tổng lợi nhuận',
    productProfitability: 'Hiệu quả sản phẩm',
    avgCostLabel: 'Chi phí trung bình',
    avgProfit: 'Lợi nhuận trung bình',
    avgMargin: 'Biên lợi nhuận trung bình',
    timesSold: 'Số lần bán',
    totalQuantity: 'Tổng số lượng',
    slowMovers: 'Bán chậm',
    lastSold: 'Lần bán cuối',
    neverSold: 'Chưa từng bán',
    inventoryOverview: 'Tổng quan tồn kho',
    averageStockValue: 'Giá trị tồn trung bình',
    lowStockCount: 'Số mặt hàng sắp hết',
    totalItems: 'Tổng số mặt hàng',
    productionLast30Days: 'Mẻ sản xuất (30 ngày)',
    totalRecipes: 'Tổng công thức',
    batchesRecorded: 'Lượt sản xuất ghi nhận',
    totalWarehouses: 'Tổng số kho',
    inactiveWarehouses: 'Kho không hoạt động',
    warehouseStatusSummary: 'Tổng quan trạng thái kho',
    addWarehouse: 'Thêm kho',
    editWarehouse: 'Chỉnh sửa kho',
    enterWarehouseName: 'Vui lòng nhập tên kho',
    warehouseCreated: 'Đã tạo kho',
    warehouseCreateFailed: 'Không thể tạo kho',
    warehouseUpdated: 'Đã cập nhật kho',
    warehouseUpdateFailed: 'Không thể cập nhật kho',
    warehouseDeleted: 'Đã xóa kho',
    warehouseDeleteFailed: 'Không thể xóa kho',
    locationUnknown: 'Chưa có vị trí',
    confirmDeleteWarehouse: 'Xóa kho này?',
    deleteWarehouseMessage: 'Hành động này không thể hoàn tác.',
    totalCategories: 'Tổng số danh mục',
    inactiveCategories: 'Danh mục không hoạt động',
    categoryStatusSummary: 'Tổng quan trạng thái danh mục',
    addCategory: 'Thêm danh mục',
    editCategory: 'Chỉnh sửa danh mục',
    enterCategoryName: 'Vui lòng nhập tên danh mục',
    categoryCreated: 'Đã tạo danh mục',
    categoryCreateFailed: 'Không thể tạo danh mục',
    categoryUpdated: 'Đã cập nhật danh mục',
    categoryUpdateFailed: 'Không thể cập nhật danh mục',
    categoryDeleted: 'Đã xóa danh mục',
    categoryDeleteFailed: 'Không thể xóa danh mục',
    categoryTag: 'Thẻ danh mục',
    categoryName: 'Tên danh mục',
    confirmDeleteCategory: 'Xóa danh mục này?',
    deleteCategoryMessage: 'Hành động này không thể hoàn tác.',
    none: 'Không',
    addAsset: 'Thêm tài sản',
    editAsset: 'Chỉnh sửa tài sản',
    assetCreatedSuccessfully: 'Tạo tài sản thành công',
    failedToCreateAsset: 'Không thể tạo tài sản',
    assetUpdatedSuccessfully: 'Cập nhật tài sản thành công',
    failedToUpdateAsset: 'Không thể cập nhật tài sản',
    assetDeletedSuccessfully: 'Đã xóa tài sản',
    failedToDeleteAsset: 'Không thể xóa tài sản',
    enterAssetName: 'Vui lòng nhập tên tài sản',
    enterValidValue: 'Nhập giá trị hợp lệ',
    enterValidYears: 'Nhập số năm sử dụng',
    totalAssets: 'Tổng tài sản',
    totalConsumption: 'Chi phí khấu hao',
    averageDepreciation: 'Khấu hao trung bình',
    confirmDeleteAsset: 'Xóa tài sản này?',
    deleteAssetMessage: 'Hành động này không thể hoàn tác.',
    menuManagement: 'Quản lý menu',
    addMenuItem: 'Thêm món',
    editMenuItem: 'Chỉnh sửa món',
    menuItemCreated: 'Đã tạo món',
    menuItemCreateFailed: 'Không thể tạo món',
    menuItemUpdated: 'Đã cập nhật món',
    menuItemUpdateFailed: 'Không thể cập nhật món',
    menuItemDeleted: 'Đã xóa món',
    menuItemDeleteFailed: 'Không thể xóa món',
    selectProduct: 'Chọn sản phẩm',
    enterValidPrice: 'Nhập giá hợp lệ',
    menuExported: 'Đã xuất menu',
    menuImported: 'Đã nhập menu',
    menuImportFailed: 'Không thể nhập menu',
    importCsv: 'Nhập CSV',

    inventory: 'Hàng tồn kho',
    stockValue: 'Giá trị tồn kho',
    lowStockAlerts: 'Cảnh báo tồn thấp',
    lowStock: 'Tồn thấp',
    inStock: 'Đủ tồn kho',
    empty: 'Hết hàng',
    topValuedMaterials: 'Nguyên liệu giá trị cao',
    stock: 'Tồn kho',
    warehouseDistribution: 'Phân bổ kho',
    quantity: 'Số lượng',
    date: 'Ngày',
    selectWarehouse: 'Chọn kho',
    addImport: 'Nhập hàng',
    addWarehouseRow: 'Thêm kho',
    removeRow: 'Xóa',
    enterCostPerUnit: 'Nhập giá mỗi đơn vị',
    saving: 'Đang lưu…',
    addProcessedMaterial: 'Thêm nguyên liệu chế biến',
    addMaterial: 'Thêm nguyên liệu',
    materialCreatedSuccessfully: 'Thêm nguyên liệu thành công!',
    materialCreateFailed: 'Không thể thêm nguyên liệu',
    useAsIngredient: 'Sử dụng làm nguyên liệu',
    bottle: 'Chai',
    can: 'Lon',
    packed: 'Đóng gói',
    name: 'Tên',
    enterName: 'Nhập tên',

    dateRange: 'Khoảng thời gian',
    week: 'Tuần',
    month: 'Tháng',
    year: 'Năm',
    thisWeek: 'Tuần này',
    thisMonth: 'Tháng này',
    thisYear: 'Năm nay',
    customRange: 'Tùy chỉnh',
    trends: 'Xu hướng',
    performanceSummary: 'Tóm tắt hiệu suất',
    averageOrderValue: 'Giá trị đơn hàng trung bình',
    itemsSold: 'Số sản phẩm bán',
    bestSellers: 'Bán chạy',
    noAnalyticsData: 'Không có dữ liệu phân tích trong khoảng này.',
    cost: 'Chi phí',
    margin: 'Biên lợi nhuận',
    inventorySummary: 'Tóm tắt tồn kho',
    lowStockItems: 'Sản phẩm sắp hết hàng',
    slowMovingProducts: 'Sản phẩm bán chậm',
    daysInStock: 'Số ngày tồn kho',
    inventoryValue: 'Giá trị tồn kho',
    noSlowMovers: 'Không tìm thấy sản phẩm bán chậm.',
    salesTrend: 'Xu hướng bán hàng',
    dailySales: 'Doanh số hàng ngày',
    profitAnalysis: 'Phân tích lợi nhuận',
    exportData: 'Xuất dữ liệu',
    selectDateRange: 'Chọn khoảng thời gian',
    startDate: 'Ngày bắt đầu',
    endDate: 'Ngày kết thúc',
    apply: 'Áp dụng',
    revenueTrendTitle: 'Xu hướng doanh thu',
    avgOrderValue: 'Giá trị đơn hàng trung bình',
    perOrder: 'mỗi đơn',
    profitable: 'Có lợi nhuận',
    sold: 'đã bán',
    growing: 'Đang tăng',
    avg: 'tb',
    allStockLevelsGood: 'Mức tồn kho đều tốt',
    categoryBreakdown: 'Phân loại theo danh mục',
    items: 'mặt hàng',
    never: 'Chưa bao giờ',
    customDateRange: 'Khoảng thời gian tùy chỉnh',
    exportAnalytics: 'Xuất dữ liệu phân tích',
    exportAnalyticsMessage: 'Xuất dữ liệu phân tích hiện tại ra tệp CSV để phân tích chi tiết.',

    sessionRequiredTitle: 'Yêu cầu đăng nhập',
    sessionRequiredMessage: 'Bạn chưa đăng nhập. Đang chuyển đến trang đăng nhập…',

    // Notifications
    notifications: 'Thông báo',
    markAllAsRead: 'Đánh dấu đã đọc tất cả',
    noNotifications: 'Không có thông báo',
    noUnreadNotifications: 'Không có thông báo chưa đọc',
    unread: 'Chưa đọc',
    info: 'Thông tin',
    success: 'Thành công',
    warning: 'Cảnh báo',
    error: 'Lỗi',
    manufacturedDate: 'Ngày sản xuất',
    manufacturedDateRequired: 'Ngày sản xuất là bắt buộc',

    categoryTagsManagement: 'Quản lý thẻ danh mục',
    totalTags: 'Tổng số thẻ',
    usedTags: 'Thẻ đã dùng',
    noCategoryTagsFound: 'Không tìm thấy thẻ danh mục',
    createFirstTagToStart: 'Tạo thẻ danh mục đầu tiên của bạn để bắt đầu tổ chức các danh mục.',
    errorLoadingTags: 'Lỗi khi tải thẻ danh mục',
    retry: 'Thử lại',
    createTag: 'Tạo Thẻ',
    editTag: 'Chỉnh sửa Thẻ',
    tagName: 'Tên Thẻ',
    enterTagName: 'Nhập tên thẻ',
    slug: 'Slug',
    urlFriendlySlug: 'Slug thân thiện với URL',
    color: 'Màu sắc',
    selectColor: 'Chọn màu sắc',
    tagDescription: 'Mô tả thẻ (tùy chọn)',
    confirmDelete: 'Xác nhận Xóa',
    deleteTagWarning: 'Bạn có chắc chắn muốn xóa thẻ này? Hành động này không thể hoàn tác.',
    tagCannotBeDeleted: 'Thẻ này không thể bị xóa vì đang được sử dụng bởi các danh mục.',
    categoryTags: 'Thẻ Danh mục',
    manageCategoryTags: 'Quản lý thẻ danh mục và màu sắc',
    theme: 'Chủ đề',
    lightTheme: 'Sáng',
    darkTheme: 'Tối',
    systemTheme: 'Hệ thống',
    darkMode: 'Chế độ Tối',
    themeOptions: 'Tùy chọn Chủ đề',
    themeOptionsDescription: 'Chọn giao diện chủ đề bạn thích:\n\n• Sáng: Chủ đề sáng cho ban ngày\n• Tối: Chủ đề tối cho ban đêm\n• Hệ thống: Tự động chuyển đổi theo cài đặt thiết bị',
    selectTheme: 'Chọn chủ đề',
    gotIt: 'Đã hiểu',
    settings: 'Cài đặt',
    actionLogs: 'Nhật ký Hành động',
    viewActionLogs: 'Xem hoạt động hệ thống và dấu vết kiểm toán',
    overview: 'Tổng quan',
    totalLogs: 'Tổng số Nhật ký',
    authEvents: 'Sự kiện Xác thực',
    criticalEvents: 'Sự kiện Quan trọng',
    recentActivity: 'Hoạt động Gần đây',
    activeFilters: 'Bộ lọc Đang hoạt động',
    clearFilters: 'Xóa Bộ lọc',
    searchLogs: 'Tìm kiếm nhật ký...',
    applyFilters: 'Áp dụng Bộ lọc',
    pullToRefresh: 'Kéo để làm mới',
    loadingMore: 'Đang tải thêm...',
    noLogsMatchFilters: 'Không có nhật ký nào khớp với bộ lọc của bạn',
    noActionLogs: 'Không tìm thấy nhật ký hành động',
    actionLogsWillAppear: 'Nhật ký hành động sẽ xuất hiện ở đây khi người dùng tương tác với hệ thống',
    exportLogs: 'Xuất Nhật ký',
    exportLogsMessage: 'Xuất nhật ký đã lọc hiện tại ra tệp CSV. Điều này sẽ tải xuống tất cả nhật ký khớp với bộ lọc hiện tại của bạn.',

    english: 'Tiếng Anh',
    vietnamese: 'Tiếng Việt',
  },
} as const;

export type TranslationKey = keyof typeof translations.en;
